var map = {
	"./communications/cool.png": "f64c",
	"./communications/have-a-good-day.png": "a19f",
	"./communications/hello.png": "9f82",
	"./communications/idea.png": "f958",
	"./communications/like.png": "bc00",
	"./communications/lol.png": "0c70",
	"./communications/miss-you.png": "c3e69",
	"./communications/no.png": "24b6",
	"./communications/ok.png": "79a8",
	"./communications/omg.png": "3271",
	"./communications/thanks.png": "eca9",
	"./communications/welcome.png": "69ef",
	"./communications/yes.png": "452f",
	"./monkey/banana.png": "55f0",
	"./monkey/celebration.png": "dd36",
	"./monkey/good.png": "6d4f",
	"./monkey/hello.png": "fd4e",
	"./monkey/lets-go.png": "a469",
	"./monkey/like.png": "9d55",
	"./monkey/no-answer.png": "1494",
	"./monkey/playing.png": "338e",
	"./worker/angry.png": "70b4",
	"./worker/break-time.png": "af92",
	"./worker/headache.png": "ccc4",
	"./worker/hurry.png": "39c7",
	"./worker/lunch-break.png": "0957",
	"./worker/mad.png": "1d7b",
	"./worker/mocking.png": "986f",
	"./worker/no-money.png": "8eb6",
	"./worker/relieve.png": "218f",
	"./worker/selfie.png": "f744",
	"./worker/sleeping.png": "0ac3",
	"./worker/surprised.png": "8fe8",
	"./worker/thinking.png": "d683",
	"./worker/throwing.png": "a078",
	"./worker/vacation.png": "4c3d",
	"./worker/win.png": "9485",
	"./worker/worrying.png": "1009"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "18e0";